
















































































import Vue from 'vue'
import auth from '../auth'
import IconMail from '@/components/icons/IconMail.vue'
import Button from '@/components/Button.vue'
import { EmailHub, AppHub } from '../event-hub'
import { EmailList } from '@/interfaces'

export default Vue.extend({
  name: 'EmailPopup',
  components: {
    IconMail,
    Button,
  },
  props: {
    subject: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeClass: '',
      isEditing: true,
      hasServerError: false,
      minMessageLength: 1,
      email: {
        subject: '',
        to: [{}],
        body: '',
      },
    }
  },
  created: function() {
    this.fetchData()
    AppHub.$on('refresh', this.fetchData)
    EmailHub.$on('openEmailPopup', this.initEmail)
  },
  beforeDestroy() {
    AppHub.$off('refresh', this.fetchData)
    EmailHub.$off('openEmailPopup', this.initEmail)
  },
  computed: {
    accountId(): string {
      return this.$store.state.accountId
    },
    getProfile() {
      return auth.getUserProfile()
    },
    titleMessage(): string {
      return this.isEditing ? this.$tc('sendUsAMessage') : this.$tc('sendUsAMessageSuccess')
    },
    emailList(): EmailList[] {
      return this.$store.state.emailList.length
        ? this.$store.state.emailList.map((person: any) => {
            return { ...person, selected: true }
          })
        : []
    },
    activeRecipients(): any {
      return this.email.to.filter((person: any) => {
        return person.selected == true
      })
    },
    isValid(): boolean {
      if (
        this.activeRecipients.length &&
        this.email.subject.length &&
        this.email.body.length >= this.minMessageLength
      ) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    fetchData() {
      if (!this.accountId) return
      this.$store.dispatch('fetchEmailList')
      this.closed()
    },
    initEmail: function(popProps: any) {
      this.email.subject = popProps.subject
      this.email.body = popProps.message
      this.email.to = popProps.mailto
        ? [{ email: popProps.mailto, selected: true }]
        : this.emailList
      this.open()
    },
    open() {
      this.isEditing = true
      this.hasServerError = false
      this.activeClass = 'active'
    },
    close() {
      this.activeClass = 'inactive'
    },
    closed() {
      this.activeClass = 'd-none'
    },
    send() {
      if (this.isValid) {
        const message = {
          ...this.email,
          subject: this.encodeString(this.email.subject),
          to: this.email.to
            .filter((person: any) => {
              return person.selected
            })
            .map((person: any) => {
              return person.email
            }),
          body: this.encodeString(this.email.body),
        }

        this.$store
          .dispatch('sendEmail', message)
          .then(response => {
            this.isEditing = false
            setTimeout(() => {
              ;(this as any).close()
            }, 1500)
          })
          .catch(error => {
            this.hasServerError = true
          })
      }
    },
    encodeString(txt: string) {
      return txt
        .replace(new RegExp('#', 'g'), '[hash]')
        .replace(new RegExp('<', 'g'), '[lt]')
        .replace(new RegExp('>', 'g'), '[gt]')
    },
  },
  watch: {
    $route(to, from) {
      this.closed()
    },
  },
})
